import React from 'react';
import SPButton from 'components/carRental/base/SPButton';
import emiter, {_EVENTS} from "../../../../events";
import { useCancelRuleTemplate } from 'hooks/product-price/cancel-rule-template';


type Props = {
    permission?: any
}

const SPPageActionBar: React.FC<Props> = (props) => {

    const { tableActionAdd } = useCancelRuleTemplate()
    const { permission } = props;
    const onCreate = () => {
        tableActionAdd({})
    }

    return (
        <div >
            <SPButton permissionKey="cancel-rule-template-create" permission={permission} type="primary" onClick={onCreate}>
                新建
            </SPButton>
        </div>
    );
};

export default SPPageActionBar;
